import {Injectable} from '@angular/core';
import {OpenIdConfiguration, StsConfigLoader} from "angular-auth-oidc-client";
import {Observable} from 'rxjs';
import {OidcConfiguration} from "./oidc-configuration.enum";
import {of} from "rxjs/internal/observable/of";
import {environment} from "../../../environments/environment.local";

@Injectable({
    providedIn: 'root'
})
export class LocalStsConfigLoader extends StsConfigLoader {

    constructor() {
        super();
    }

    loadConfigs(): Observable<OpenIdConfiguration[]> {
        return of([this.getLocalConfig()]);
    }

    private getLocalConfig(): OpenIdConfiguration {
        return {
            configId: OidcConfiguration.Auth0,
            authority: environment.auth0.authority,
            clientId: environment.auth0.clientId,
            redirectUrl: globalThis.location.origin + '/callback',
            postLogoutRedirectUri: globalThis.location.origin,
            scope: environment.auth0.scope,
            responseType: 'id_token',
            silentRenew: false,
            useRefreshToken: false,
            logLevel: 0,
        } as OpenIdConfiguration;
    }
}
